import { render, staticRenderFns } from "./editPlusRecordNormal.vue?vue&type=template&id=04420e47&scoped=true&"
import script from "./editPlusRecordNormal.vue?vue&type=script&lang=js&"
export * from "./editPlusRecordNormal.vue?vue&type=script&lang=js&"
import style0 from "./editPlusRecordNormal.vue?vue&type=style&index=0&id=04420e47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04420e47",
  null
  
)

export default component.exports